import { ApiResponse } from "@/types/api.types";
import baseApi from "./RootBaseApi";
import { ProfileResponse, UpdateProfilePayload } from "@/types/profile.types";
import {
  NotificationPreferencesDto,
  NotificationPreferencesResponseDto,
} from "@/types/notification.types";

export const ProfileService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProfile: builder.query<ApiResponse<ProfileResponse>, void>({
      query: () => ({
        url: "admin/profile",
        method: "GET",
      }),
      transformResponse: (response: ApiResponse<ProfileResponse>) => response,
    }),

    updateProfile: builder.mutation<
      ApiResponse<ProfileResponse>,
      UpdateProfilePayload | FormData
    >({
      query: (user) => {
        return {
          url: "admin/profile",
          method: "PUT",
          data: user,
        };
      },
      transformResponse: (response: ApiResponse<ProfileResponse>) => response,
    }),

    getNotificationPreferences: builder.query<
      NotificationPreferencesResponseDto,
      void
    >({
      query: () => ({
        url: "users/notification-preferences",
        method: "GET",
      }),
      transformResponse: (response: NotificationPreferencesResponseDto) =>
        response,
    }),

    updateNotificationPreferences: builder.mutation<
      NotificationPreferencesResponseDto,
      NotificationPreferencesDto
    >({
      query: (preferences) => ({
        url: "users/notification-preferences",
        method: "PATCH",
        data: preferences,
      }),
      transformResponse: (response: NotificationPreferencesResponseDto) =>
        response,
    }),
  }),
});

export const {
  useGetProfileQuery,
  useUpdateProfileMutation,
  useGetNotificationPreferencesQuery,
  useUpdateNotificationPreferencesMutation,
} = ProfileService;
